import React, { ReactNode } from 'react';
import styles from './styles.module.scss';

const Checkbox = ({
  className = '',
  checked = false,
  onChange = () => {},
  checkMarkStyle = '',
  wrapper = '',
  labelStyle = '',
  title = null,
  titleClass = '',
}: {
  className?: string;
  checked?: boolean;
  onChange: () => void;
  checkMarkStyle?: string;
  wrapper?: string;
  labelStyle?: string;
  title?: string | null | ReactNode;
  titleClass?: string;
}) => {
  return (
    <div style={{ height: '20px' }} className={`${styles.wrapper} ${wrapper}`}>
      <label className={`${styles.container}  ${className} ${labelStyle}`}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className={`${styles.checkmark}  ${checkMarkStyle}`}></span>
      </label>
      {title && <span className={`${styles.itemTitle} ${titleClass}`}>{title}</span>}
    </div>
  );
};

export default Checkbox;
